<template>

    <article v-show="isActive">

        <slot/>

    </article>
	
</template>





<script>

    export default {

        name: 'WizardTab',
        props: {

            name: {
                type: String,
                required: true
            },
            selected: {
                type: Boolean,
                required: false
            },
            id: {
                type: [ String, Number ],
                required: true
            }

        },
        data() {
            return {

                isActive: false

            }
        },
        mounted() {
            
            this.isActive = this.selected;
            
        }

    };

</script>